import React from "react";
import "./commonBtn.css";
import { toast } from "react-toastify";

type Props = {
  status: number;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  disabled?: boolean;
  children: any;
};

const CommonBtn: React.FC<Props> = ({
  status,
  onClick,
  children,
  disabled,
}) => {
  // toast.info(window.navigator.platform);
  const mac = window.navigator.platform.indexOf("Mac") > -1;
  const chrome = window.navigator.userAgent.indexOf("Chrome") > -1;
  return (
    <button
      className={`common-btn common-btn-status-${status}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default CommonBtn;
